// Feature flags.
//
// The visual email-template editor (custom automated-message templates,
// per-language editing, custom scheduled emails) and the Newsletter are still in
// active development. They are enabled ONLY in local development and disabled in
// the production build (import.meta.env.DEV is true under `vite dev`, false in
// the deployed `vite build`). Force-enable locally/preview with VITE_EMAIL_EDITOR=1.
//
// On production the Automated-messages page keeps just: preview of the predefined
// messages + "send me a test" to a chosen address.
export const EMAIL_EDITOR_ENABLED: boolean =
  import.meta.env.DEV || import.meta.env.VITE_EMAIL_EDITOR === '1';
